export const FETCH_REQUEST = 'categories/FETCH_REQUEST'
export const FETCH_SUCCESS = 'categories/FETCH_SUCCESS'
export const FETCH_FAILURE = 'categories/FETCH_FAILURE'

export const CREATE_REQUEST = 'categories/CREATE_REQUEST'
export const CREATE_SUCCESS = 'categories/CREATE_SUCCESS'
export const CREATE_FAILURE = 'categories/CREATE_FAILURE'

export const EDIT_REQUEST = 'categories/EDIT_REQUEST'
export const EDIT_SUCCESS = 'categories/EDIT_SUCCESS'
export const EDIT_FAILURE = 'categories/EDIT_FAILURE'

export const DELETE_REQUEST = 'categories/DELETE_REQUEST'
export const DELETE_SUCCESS = 'categories/DELETE_SUCCESS'
export const DELETE_FAILURE = 'categories/DELETE_FAILURE'
